import type { AuthIdentity, ActionCardStatus } from "@aos/shared";

export const TERMINAL_ACTION_CARD_STATUSES = new Set<ActionCardStatus>([
  "completed",
  "rejected",
  "expired",
  "superseded",
  "cancelled",
]);

export const OPEN_ACTION_CARD_STATUSES = new Set<ActionCardStatus>([
  "proposed",
  "deferred",
  "accepted",
  "failed",
]);

export interface ActionCardActionTarget {
  id: string;
  status: ActionCardStatus;
  approval_mode: string;
}

export function isTerminalActionCard(status: ActionCardStatus): boolean {
  return TERMINAL_ACTION_CARD_STATUSES.has(status);
}

export function canLifecycleAction(card: ActionCardActionTarget): boolean {
  return !isTerminalActionCard(card.status);
}

export function canAcceptActionCard(card: ActionCardActionTarget): boolean {
  return (
    card.status === "proposed" ||
    card.status === "deferred" ||
    card.status === "failed"
  );
}

export function canReopenActionCard(card: ActionCardActionTarget): boolean {
  return card.status === "deferred" || card.status === "failed";
}

export function actionCardPrimaryLabel(
  card: Pick<ActionCardActionTarget, "approval_mode" | "status">,
): string {
  if (card.status === "accepted") return "Accepted";
  if (card.approval_mode === "forbidden") return "Forbidden";
  return card.approval_mode === "auto_allowed" ? "Accept" : "Request approval";
}

export function resolveActionActorId(
  identity: Pick<AuthIdentity, "id"> | null | undefined,
): string | null {
  const id = identity?.id?.trim();
  if (!id) return null;
  if (id.startsWith("actor_")) return id;
  if (id.startsWith("user_")) return `actor_${id}`;
  return `actor_${id}`;
}

export function parseJsonText(value: string | null | undefined): unknown {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

export function formatScore(value: number | null | undefined): string {
  if (value === null || value === undefined) return "-";
  return value.toFixed(2);
}
